import { ScToast } from '@intelipost-js/secure-components';
import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getLogList({ commit }, params) {
    commit('setLoadingLogList', true);

    return GraphQlClient.query(`
      query($page: Int, $size: Int) {
        listCTeProcessingLogs(
          page: $page,
          size: $size
        ) {
          total_size,
          logs {
            filename
            cte_identifier
            logistic_provider_id
            processing_date_time
            file_source
            processing_description
          }
        }
      }`, params)
      .then(({ data }) => {
        const { listCTeProcessingLogs } = data || {};
        commit('setCTeLogList', listCTeProcessingLogs.logs || []);
        commit('setCTeLogListTotal', listCTeProcessingLogs.total_size || 0);
        commit('setLoadingLogList', false);
      }).catch(() => {
        ScToast.danger('Falha ao buscar os logs de CT-e');
        commit('setLoadingLogList', false);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/cte-logs/store/actions.js